import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePermissions } from '@/composables/auth/usePermissions';
import { useUpdateTransaction } from '@/composables/financial/useUpdateTransaction';
import { TRANSACTION_KINDS } from '@/lib/constants';
import type { Transaction, TransactionKind } from '@/types/table';

/**
 * What a ledger row counts as: this is what decides whether it is income, an
 * expense, or neither on the Financial Overview. Admins can correct it here.
 */
export function TransactionKindCell({ transaction }: { transaction: Transaction }) {
  const { hasRole } = usePermissions();
  const update = useUpdateTransaction();
  const label = TRANSACTION_KINDS.find((k) => k.value === transaction.kind)?.label ?? transaction.kind;

  if (!hasRole('ADMIN')) return <span>{label}</span>;

  const options = TRANSACTION_KINDS.filter((k) => (k.types as readonly string[]).includes(transaction.type));
  return (
    // The list row opens on click; choosing a value here shouldn't.
    <div onClick={(e) => e.stopPropagation()}>
      <Select
        value={transaction.kind}
        disabled={update.isPending}
        onValueChange={(kind) => update.mutate({ id: transaction.id, data: { kind: kind as TransactionKind } })}
      >
        <SelectTrigger className="h-8 w-36 text-xs" aria-label="Counts as"><SelectValue /></SelectTrigger>
        <SelectContent>{options.map((k) => <SelectItem key={k.value} value={k.value}>{k.label}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}
